import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    color: theme.palette.textcolor.main,
    textTransform: 'uppercase',
    fontSize: '1.4375em',
    fontStyle: 'italic',
    marginBottom: 10,
  },
  text: {
    color: '#000000',
    display: 'block',
    maxWidth: 700,
    marginBottom: 20,
  },
  filtersWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // marginTop: 20,
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  filtersLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  chartsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 30,
    alignItems: 'center',
  },
  chartsContainer: {
    // display: 'flex',
    // justifyContent: 'space-between',
    // flexWrap: 'wrap',
    width: '60%',
  },
  formControl: {
    margin: `${theme.spacing(1)}px 0`,
    minWidth: 165,
    marginTop: '23px',
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      padding: '6px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(1px, -12px) scale(0.75) !important',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(1px, -12px) scale(0.75) !important',
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#5C5C5C',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.4em',
    },
    '& .MuiSelect-icon': {
      top: 'calc(50% - 9px)',
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  inputLabel: {
    color: '#5C5C5C',
  },
  search: {
    position: 'relative',
    borderRadius: 5,
    marginLeft: 0,
    width: 165,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  inputRoot: {
    color: 'inherit',
    backgroundColor: 'transparent',
    border: '1px solid #C1C1BF',
    borderRadius: 4,
    paddingRight: '10px !important',
    fontSize: 12,
    paddingBottom: 0,
    paddingLeft: 6,
    '& input': {
      fontSize: 16,
    },
  },
  inputField: {
    marginTop: 0,
    '& .MuiInputLabel-root': {
      paddingLeft: 6,
      fontFamily: 'Source Sans Pro, sans-serif',
    },
    '& .Mui-focused': {
      color: '#5C5C5C',
    },
    '& .MuiInputLabel-formControl': {
      transform: 'translate(0, 29px) scale(1)',
    },
    '& .MuiInputLabel-shrink': {
      paddingLeft: '0 !important',
      transform: 'translate(0, 10px) scale(0.75)',
      transformOrigin: 'top left',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:focus:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child': {
      padding: '4px 0 4px 0',
    },
    '& .MuiAutocomplete-clearIndicator': {
      backgroundColor: '#CF1F3890',
      color: '#FFFFFF',
      top: 1,
      marginRight: 0,
      '&:hover': {
        backgroundColor: '#CF1F38',
      },
    },
    '& .MuiAutocomplete-popupIndicator': {
      marginRight: 0,
      padding: 5,
    },
    '& .MuiSvgIcon-root': {
      width: '0.65em',
      height: '0.65em',
    },
    '& .MuiInputBase-adornedStart': {
      border: '1px solid #28a745 !important',
      '& .MuiAutocomplete-clearIndicator': {
        visibility: 'visible !important',
      },
    },
    '& label + .MuiInput-formControl': {
      marginTop: '22px',
    },
  },
  selectedSpan: {
    marginRight: 8,
    color: '#28a745',
    cursor: 'default',
    maxWidth: 155,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  popperOptions: {
    '& li': {
      padding: 0,
      margin: 0,
    },
  },
  option: {
    fontSize: 14,
    padding: '6px 8px !important',
    margin: '0 !important',
    width: '100%',
  },
  selected: {
    backgroundColor: '#28a745 !important',
    color: '#FFFFFF !important',
  },
}));

export default useStyles;
